
import styled from 'styled-components';

export const StyledHome = styled.section`
    width: 100vw;
    height: 100vh;
    margin: 0 auto;

    .container-scroll {
        overflow: auto;
        scroll-behavior: smooth;
        height: 86%;

        ::-webkit-scrollbar{
        background-color: var();
        width: 5px;
        height: 5px;
        border-radius: 8px;
        }
    }

`
    